import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default class SliderEnola {
    static initAll() {
        const sliders = document.querySelectorAll('.slider-enola > .swiper');

        if (!sliders)
            return;

        const config = {
            modules: [Pagination, Navigation],
            pagination: {
                el: ".swiper-pagination-enola",
                type: "bullets",
                clickable: true,
            },
            navigation: {
                prevEl: '.swiper-button-prev-enola',
                nextEl: '.swiper-button-next-enola',
            },
            direction: "horizontal",
            slidesPerView: 1.5,
            spaceBetween: 20,
            allowTouchMove: true,
            slidesOffsetAfter: 20,
            grabCursor: true,
            breakpoints: {
				600: {
					slidesPerView: 2.5,
					spaceBetween: 40,
                    slidesOffsetAfter: 40,
				},
            }
        };

        sliders.forEach((slider) => {
            new Swiper(slider, config);
        });
    }

}